import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-videoplayer',
  templateUrl: './videoplayer.component.html',
  styleUrls: ['./videoplayer.component.css']
})
export class VideoplayerComponent implements OnInit {
  @Input() id: any;

  constructor() { }

  ngOnInit(): void {
  }

}
